export const GlobalTheme = {
    borderRadius: '2px',
    maxWidth: '1200px',
    dropShadow: ' drop-shadow(0px 2px 4px #000)',
    breakpoint: {
        xs: '430px',
        sm: '576px',
        md: '767px',
        lg: '1000px',
        xl: '1500px',
    }
}
